import i18n from '../i18n';
import { API_ERROR_KEYS } from '../i18n/apiErrorKeys';
import { API_ERROR_PATTERNS } from '../i18n/apiErrorPatterns';

/**
 * Show an API error in the interface language.
 *
 * The backend speaks Russian in its `detail` strings. A client running in English used to
 * read those verbatim in a toast, which is the one place the language switch could not
 * reach. The sentence is looked up by its exact text; anything unknown (a dynamic message,
 * a provider's own error, an English message) is returned untouched, so nothing is lost.
 */
export const translateApiError = (text) => {
  if (typeof text !== 'string' || !text) return text;
  const trimmed = text.trim();
  const key = API_ERROR_KEYS[trimmed];
  try {
    if (key) return i18n.t(`apiErrors.${key}`, { defaultValue: text });
    // messages built around a value (an id, a file name, a limit)
    for (const entry of API_ERROR_PATTERNS) {
      const match = entry.pattern.exec(trimmed);
      if (match) {
        return i18n.t(`apiErrorPatterns.${entry.key}`, {
          defaultValue: text,
          value: match.groups?.value ?? '',
        });
      }
    }
    return text;
  } catch {
    // i18next not ready yet: the API wording is still the honest answer
    return text;
  }
};
